import { AGENT, BRANCH, TEAM } from '../constants/filtersConstants';

/**
 * The current user as an agent scope filter. Includes branch_id when the
 * user payload has one, so every screen that seeds this filter stores the
 * same item.
 */
export function selfAgentFilter(user) {
  if (!user?.id) return null;
  const filter = {
    id: user.id,
    text: user.full_name,
    filter_type: AGENT,
  };
  if (user.branch?.id != null) filter.branch_id = user.branch.id;
  return filter;
}

/**
 * Normalizes a string to lowercase, removes accents and diacritics.
 * Useful for performing accent-insensitive searches.
 */
export function normalizeText(str) {
  return str
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Sorts an array of objects by the `full_name` property using Spanish locale.
 */
export function sortByKeyEs(array, key) {
  return array
    .slice()
    .sort((a, b) =>
      a[key]?.localeCompare(b[key], 'es', { sensitivity: 'base' })
    );
}

/**
 * Generates label text for a selection button based on the selected items.
 *
 * - If no items selected → returns fallback text.
 * - If one item selected → returns the item's full name.
 * - If multiple items → returns "FirstName + N".
 */
export function formatSelectedText(items, fallbackText, type) {
  const filterItems = items.filter((item) => item.filter_type === type);

  if (filterItems.length === 0) return fallbackText;
  if (filterItems.length === 1) return filterItems[0].text || fallbackText;
  return `${filterItems[0].text} + ${filterItems.length - 1}`;
}

export function toAgentScopeItem(agent) {
  return {
    id: agent.id,
    text: agent.full_name || agent.name || '',
    filter_type: AGENT,
    branch_id: agent.branch?.id,
  };
}

export function toBranchScopeItem(branch) {
  return {
    id: branch.id,
    text: branch.name,
    filter_type: BRANCH,
  };
}

export function toTeamScopeItem(team) {
  return {
    id: team.id,
    text: team.name,
    filter_type: TEAM,
  };
}

export const SCOPE_TOOLTIP_NAME_LIMIT = 20;

export function joinSelectionNames(
  items,
  orWord,
  limit = SCOPE_TOOLTIP_NAME_LIMIT
) {
  const names = (items || []).map((item) => item.text).filter(Boolean);
  const visible = names.slice(0, limit);
  const extra = names.length - visible.length;
  const label = visible.join(` ${orWord} `);
  return extra > 0 ? `${label} +${extra}` : label;
}

export function selectionTooltip(items, { allSelected, allLabel, orWord }) {
  if (!items?.length) return '';
  if (allSelected) return allLabel;
  return joinSelectionNames(items, orWord);
}

export function getIsAllSelected(selected, items, type) {
  if (selected.length === 0) return false;

  const filteredSelected = selected.filter((item) => item.filter_type === type);
  return filteredSelected.length === items.length;
}
